import { DonationSummary } from "./DonationSummary";
import { useDonationFormStore } from "@/stores";
import type { DonationSummaryWithStoreProps } from "./DonationSummaryProps";

export function DonationSummaryWithStore({
  config,
  className,
  collapsible,
}: DonationSummaryWithStoreProps) {
  const {
    isUKTaxPayer,
    address,
    donationAmount,
    donationType,
    personalDetails,
    signUpFrontline,
    donationSource,
    cardSelector,
    cardEnabled,
    onBehalf,
    organisationName,
  } = useDonationFormStore();

  const formattedAddress = [
    address["address-line-1"],
    address["address-line-2"],
    address.city,
    address.region,
    address["postal-code"],
    address.country,
  ]
    .map((part) => part.trim())
    .filter(Boolean)
    .join(", ");

  const name =
    `${personalDetails.title} ${personalDetails.firstName} ${personalDetails.lastName}`.trim();

  return (
    <DonationSummary
      donationType={donationType}
      donationAmount={donationAmount}
      isUKTaxPayer={isUKTaxPayer}
      name={name}
      email={personalDetails.email}
      address={formattedAddress}
      isSubscribed={signUpFrontline}
      donationSource={donationSource}
      cardSelector={cardSelector}
      cardEnabled={cardEnabled}
      onBehalf={onBehalf}
      organisationName={organisationName}
      config={config}
      className={className}
      collapsible={collapsible}
    />
  );
}
